import cn from 'classnames';
import type { JSX } from 'preact';
import styles from './CloseButton.module.scss';

export type CloseButtonProps = {
  /** The close button aria-label */
  ariaLabel: string;
  class?: string;
  onClose: (e: JSX.TargetedEvent<HTMLButtonElement>) => void;
};

function CloseButton({
  ariaLabel,
  class: className,
  onClose
}: CloseButtonProps) {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <button
      class={cn(styles.closeButton, className)}
      tabIndex={0}
      type="button"
      onClick={onClose}
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
      aria-label={ariaLabel}
    />
  );
}
export default CloseButton;
